const config = () => ({
  conversation: 'none',
  cards: 'visible',
  theme: 'light',
  width: 'auto',
  dnt: false,
})

export type configType = ReturnType<typeof config>
export default config
